export default __webpack_public_path__ + "static/media/group-629@3x.0eb7960e.png";